import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16">
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="mt-3 text-white/60">That page does not exist.</p>
      <Link to="/" className="mt-6 inline-flex rounded-xl border border-white/15 bg-white/10 px-5 py-3 text-sm hover:bg-white/15">Go home</Link>
    </div>
  )
}
